import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import ProjectDetail from "./components/ProjectDetail";
import CVPage from "./components/CVPage";
import Impressum from "./components/Impressum";
import Admin from "./components/Admin";
import { TrackingProvider } from "./contexts/TrackingContext";

function App() {
  return (
    <Router>
      <TrackingProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project/:projectId" element={<ProjectDetail />} />
          <Route path="/cv" element={<CVPage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </TrackingProvider>
    </Router>
  );
}

export default App;
